export default __webpack_public_path__ + "assets/GroupOfMiners.8cff.svg";